import { Container } from "react-bootstrap";
import OperatorPerformance from "../../../components/molecules/OperatorPerformanceWidget/OperatorPerformance";
import BreadCrumb from "../../../components/organisms/Breadcrumb/BreadCrumb";
import PageTitle from "../../../components/organisms/Headline/PageTitle";

const ListOfOperators = () => {
  return (
    <Container fluid className="layout-bar">
      <BreadCrumb />
      <PageTitle
        title="Operator Performance"
        subTitle="Real-time performance metrics and status tracking"
      />
      <div className="operator-performance operator-page">
        <OperatorPerformance
          pageSize={5}
          isShowFilter={true}
          isShowRejectionRate={true}
          isShowView={true}
          isShowViewAll={false}
          isHotWarmPercentage={true}
          isShowGuide={true}
        />
      </div>
    </Container>
  );
};

export default ListOfOperators;
